module.exports = __webpack_public_path__ + "static/media/uttam2zoom.a12586cb.jpg";